// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-live[data-v-7d2b3d3e]{background-color:#8b1e33}.center-icon[data-v-7d2b3d3e]{text-decoration:none;display:flex;align-items:center;text-transform:uppercase;font-weight:600;font-size:1rem;line-height:1rem}.small[data-v-7d2b3d3e]{font-size:.7rem!important}.center-icon[data-v-7d2b3d3e]:hover{color:#ea9606!important}", ""]);
// Exports
module.exports = exports;
